import React from "react";

import { useTranslation } from "react-i18next";

import { ResponsiveTitleBar, LinkButton } from "../Atoms";
import { StartTabCheckoutSession } from "../Checkout/TablePayPayment";

export const LetTheGoodTimesRoll = () => {
  const { t } = useTranslation();
  return (
    <div className="border-venue-primary border-dashed border-y py-32 text-5xl font-bold text-center">
      {t("billSplit.letTheGoodTimes")}
    </div>
  );
};
export const JoinBillSplitSession = ({}: {}) => {
  const { t } = useTranslation();
  return (
    <div className="space-y-32 max-w-screen-sm mx-auto">
      <ResponsiveTitleBar>{t("billSplit.settleUp")} </ResponsiveTitleBar>
      <LetTheGoodTimesRoll />
      <div className="space-y-16">
        <h2 className="text-2xl font-bold">
          {" "}
          {t("billSplit.payForEverything")}
        </h2>
        <StartTabCheckoutSession />
      </div>
      <div className="text-5xl font-bold uppercase text-center leading-loose ">
        {t("billSplit.or")}
      </div>
      <div className="space-y-16">
        <h2 className="text-2xl font-bold">
          {t("billSplit.splitBillWithTable")}
        </h2>
        <LinkButton primary to="../customer">
          {t("billSplit.startSplitting")}
        </LinkButton>
      </div>
    </div>
  );
};
